module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp1_6005.e1b10ae6.png";